/** Shared arc and inward arrows for manual and editable wall angles. */
export function renderAngularDimensionArc(parent, points, { svgEl, visualScale, lineAttrs = {}, arrowAttrs = {}, hitAttrs = null }) {
  if (points.length < 2) return;
  const d = points.map((p, i) => `${i ? 'L' : 'M'}${p.x},${p.y}`).join(' ');
  svgEl('path', { d, class: 'dimension-line', ...lineAttrs }, parent);
  if (hitAttrs) svgEl('path', { ...hitAttrs, d, fill: 'none', class: 'dimension-hit-line' }, parent);
  const arcLengthPx = points.slice(1).reduce((sum, p, i) => sum + Math.hypot(p.x - points[i].x, p.y - points[i].y), 0);
  const arrow = (tip, toward) => {
    const dx = toward.x - tip.x, dy = toward.y - tip.y;
    const length = Math.hypot(dx, dy) || 1;
    const ux = dx / length, uy = dy / length;
    const size = Math.min(visualScale, arcLengthPx / 55);
    const bx = tip.x + ux * 11 * size, by = tip.y + uy * 11 * size;
    svgEl('polygon', { class: 'dimension-arrow', ...arrowAttrs,
      points: `${tip.x},${tip.y} ${bx - uy * 3.5 * size},${by + ux * 3.5 * size} ${bx + uy * 3.5 * size},${by - ux * 3.5 * size}`
    }, parent);
  };
  arrow(points[0], points[1]);
  arrow(points.at(-1), points.at(-2));
}

/** Uses the existing dimension classes, label metrics, handles and export path. */
export function renderAngularDimension(parent, dimension, layout, ctx, options = {}) {
  if (!layout) return null;
  const { svgEl, worldToScreen, labelMetrics } = ctx;
  const screen = p => worldToScreen(p.x, p.z);
  const attrs = { 'data-dimension-id': dimension.id || '' };
  const group = svgEl('g', { ...attrs,
    style: `--dimension-visual-scale:${labelMetrics.fontSizePx / 12}`,
    class: `dimension angular-dimension ${options.statusClass || ''}${options.selected ? ' is-selected' : ''}${options.preview ? ' is-preview' : ''}`
  }, parent);
  const line = (a, b, className) => {
    const start = screen(a), end = screen(b);
    svgEl('line', { x1: start.x, y1: start.y, x2: end.x, y2: end.y, class: className }, group);
  };
  if (layout.parallel) line(layout.pointA, layout.pointB, 'dimension-extension-line');
  else {
    line(layout.pointA, layout.dimA, 'dimension-extension-line');
    line(layout.pointB, layout.dimB, 'dimension-extension-line');
    const points = layout.arcPoints.map(screen);
    renderAngularDimensionArc(group, points, { svgEl, visualScale: labelMetrics.fontSizePx / 12, hitAttrs: attrs });
  }
  const text = screen(layout.textPosition);
  const label = svgEl('text', { ...attrs, class: 'dimension-text', x: text.x, y: text.y,
    'text-anchor': 'middle', 'dominant-baseline': 'central', 'font-size': labelMetrics.fontSizePx,
    'data-plan-label-size': labelMetrics.size, 'data-plan-label-scale-mode': labelMetrics.scaleMode,
    ...(options.selected && !options.preview ? { 'data-dimension-handle': 'offset' } : {})
  }, group);
  label.textContent = options.label;
  return group;
}
